const initialstate = {
  data:[],
  msgdata:[],
  forgotpass:[],
  
}

const OrgDonationsReducers =  (state = initialstate, action:any)=>{
  switch (action.type){
      case 'fetch_data_success':
          return {... state, data:action.payload};
          case 'fetch_msg_data_success':
          return {... state, msgdata:action.payload};
          case 'FETCH_DATA_SUCCESS':
            return {... state, forgotpass:action.payload};
                     default :
          return state;
  }
};
export default OrgDonationsReducers;